var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "history" },
    [
      _c("div", {
        staticClass: "el-icon-arrow-left more-icon-3 cursor hide",
        attrs: { id: "back-to-main" },
        on: { click: _vm.backToChart }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "history-title" }, [_vm._v("聊天记录")]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: { id: "history-main" }
        },
        _vm._l(_vm.historyData, function(item, index) {
          return _c("div", { key: index }, [
            item.chatType === 0
              ? _c("div", { staticClass: "one-history" }, [
                  _c("div", {
                    staticClass: "avatar",
                    style:
                      "background:url(" +
                      (item.sendUser.avatarImageUrl
                        ? item.sendUser.avatarImageUrl
                        : require("../../../static/avatar.jpg")) +
                      ") 0 0 no-repeat;"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-data" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("span", { class: ["name", item.color] }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { class: ["date", item.color] }, [
                        _vm._v(_vm._s(item.createdTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "word-break fs-15" }, [
                      _vm._v(_vm._s(item.content))
                    ])
                  ])
                ])
              : item.chatType === 1
              ? _c("div", { staticClass: "one-history" }, [
                  _c("div", {
                    staticClass: "avatar",
                    style:
                      "background:url(" +
                      (item.sendUser.avatarImageUrl
                        ? item.sendUser.avatarImageUrl
                        : require("../../../static/avatar.jpg")) +
                      ") 0 0 no-repeat;"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-data" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("span", { class: ["name", item.color] }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { class: ["date", item.color] }, [
                        _vm._v(_vm._s(item.createdTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "word-break" },
                      [
                        _c("el-image", {
                          staticStyle: { "max-width": "100%" },
                          attrs: {
                            src: item.content,
                            "preview-src-list": _vm.imgList
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : item.chatType === 2
              ? _c("div", { staticClass: "one-history" }, [
                  _c("div", {
                    staticClass: "avatar",
                    style:
                      "background:url(" +
                      (item.sendUser.avatarImageUrl
                        ? item.sendUser.avatarImageUrl
                        : require("../../../static/avatar.jpg")) +
                      ") 0 0 no-repeat;"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-data" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("span", { class: ["name", item.color] }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { class: ["date", item.color] }, [
                        _vm._v(_vm._s(item.createdTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "left-chart one-chart" }, [
                      _c("span", { staticClass: "chart-line" }, [
                        _c("div", { staticClass: "t-c file-box" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/file/" +
                                item.content.typeImg)
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "file-text" }, [
                            _c("div", { staticClass: "file-name" }, [
                              _vm._v(_vm._s(item.content.fileOriginName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "file-size ft-r fs-12" }, [
                              _vm._v(_vm._s(item.content.fileSizeKb) + "KB")
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "inline-block ft-l fs-12",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(
                                      item.content.id,
                                      item.content.fileOriginName
                                    )
                                  }
                                }
                              },
                              [_vm._v("下载附件")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              : item.chatType === 3
              ? _c("div", { staticClass: "one-history" }, [
                  _c("div", {
                    staticClass: "avatar",
                    style:
                      "background:url(" +
                      (item.sendUser.avatarImageUrl
                        ? item.sendUser.avatarImageUrl
                        : require("../../../static/avatar.jpg")) +
                      ") 0 0 no-repeat;"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-data" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("span", { class: ["name", item.color] }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { class: ["date", item.color] }, [
                        _vm._v(_vm._s(item.createdTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "left-chart one-chart" }, [
                      _c("span", { staticClass: "chart-line" }, [
                        _c("div", { staticStyle: { position: "relative" } }, [
                          _c("span", [_vm._v(_vm._s(item.content.comment))]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0);" },
                              on: { click: _vm.risButtonClick }
                            },
                            [_vm._v("详情>")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "t-c file-box" }, [
                          _c("div", { staticClass: "ris-data" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/" + item.content.img)
                              }
                            }),
                            _vm._v(" "),
                            _c("strong", { staticClass: "fs-15" }, [
                              _vm._v(_vm._s(item.content.patientName))
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              class: ["iconfont", item.content.icon]
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "fs-13" }, [
                              _vm._v(_vm._s(item.content.age))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ris-content fs-15 ellipse text-left"
                            },
                            [_vm._v(_vm._s(item.content.projectName))]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              : item.chatType === 4
              ? _c("div", { staticClass: "one-history" }, [
                  _c("div", {
                    staticClass: "avatar",
                    style:
                      "background:url(" +
                      (item.sendUser.avatarImageUrl
                        ? item.sendUser.avatarImageUrl
                        : require("../../../static/avatar.jpg")) +
                      ") 0 0 no-repeat;"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-data" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("span", { class: ["name", item.color] }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { class: ["date", item.color] }, [
                        _vm._v(_vm._s(item.createdTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "left-chart one-chart" }, [
                      _c(
                        "div",
                        {
                          staticClass: "chart-line cursor",
                          on: {
                            click: function($event) {
                              return _vm.voiceLineClick(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "triangle-left" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "voice-block flex-left",
                              style: "width:" + item.content.width + "px"
                            },
                            [
                              _c("div", { staticClass: "inline-block" }, [
                                _vm._v(_vm._s(item.content.Time) + "s")
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                class: [
                                  "trumpet",
                                  "trumpet-left",
                                  item.voicePlay ? "voicePlay" : ""
                                ]
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : item.chatType === 5
              ? _c("div", { staticClass: "one-history" }, [
                  _c("div", {
                    staticClass: "avatar",
                    style:
                      "background:url(" +
                      (item.sendUser.avatarImageUrl
                        ? item.sendUser.avatarImageUrl
                        : require("../../../static/avatar.jpg")) +
                      ") 0 0 no-repeat;"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-data" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("span", { class: ["name", item.color] }, [
                        _vm._v(_vm._s(item.sendUser.userName))
                      ]),
                      _vm._v(" "),
                      _c("span", { class: ["date", item.color] }, [
                        _vm._v(_vm._s(item.createdTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "other-msg" }, [
                      _c("span", [_vm._v(_vm._s(item.content))])
                    ])
                  ])
                ])
              : _vm._e()
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("ky-preview-dialog", {
        attrs: { url: _vm.url, visible: _vm.visible, type: _vm.previewType },
        on: {
          "update:visible": function($event) {
            _vm.visible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52df1714", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52df1714","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/history.vue
// module id = null
// module chunks = 